import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { GoogleAdsIntegration } from 'api/clients/ExternalIntegrationsClient'
import { useDeleteExternalIntegration } from 'hooks/queries/externalIntegrations/useDeleteExternalIntegration'

interface Props {
  integration: GoogleAdsIntegration
  onClose: () => void
}

export const GoogleAdsConversionTrackingModal = ({ integration, onClose }: Props) => {
  const { closeModal } = useModals()
  const { mutateAsync: deleteIntegration, isLoading } = useDeleteExternalIntegration(integration.id)

  const handleClose = async () => {
    try {
      await deleteIntegration()
    } catch {
      // deletion failure should not block the user from closing
    }
    closeModal()
    onClose()
  }

  return (
    <Modal.Root size="sm" onPressOutside={() => {}} onClose={() => {}} aria-label="Conversion Tracking Required">
      <Modal.Header title="Conversion Tracking Required" />
      <Modal.Content>
        <Text>
          We couldn&apos;t find any conversion actions with conversions recorded in the last 30 days in your Google Ads
          account.
        </Text>
        <br />
        <Text>
          Conversion tracking is required to run campaigns through Blaze. Please set up conversion tracking in Google
          Ads, then reconnect your account.
        </Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton variant="primary" onPress={handleClose} isDisabled={isLoading}>
            {isLoading ? 'Closing...' : 'Close'}
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
